import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

const BottomNavScanIcon = ({ primaryColor = '#414042', size, style, secondaryColor, textColor, ...rest }) => (
    <SvgIcon viewBox='0 0 17.5 17.54' style={size ? { ...style, fontSize: size, width: size, height: size } : style} {...rest}>
        <path
            fill={primaryColor}
            d='M.57,0c-.15,0-.3.06-.41.17-.11.11-.17.26-.17.41v3.94c0,.32.26.57.57.57s.57-.26.57-.57V1.15h3.36,0c.32,0,.57-.26.57-.57,0-.15-.06-.3-.17-.41-.11-.11-.25-.17-.41-.17H.57ZM12.99,0h0c-.15,0-.3.06-.41.17-.11.11-.17.26-.17.41,0,.32.26.57.57.57h3.36v3.37c0,.32.26.57.57.57s.57-.26.57-.57V.58c0-.15-.06-.3-.17-.41-.11-.11-.25-.17-.41-.17h-3.94ZM.57,12.45C.26,12.45,0,12.71,0,13.03v3.95c0,.32.26.57.57.57h3.93c.32,0,.57-.26.57-.57s-.26-.57-.57-.57H1.15v-3.37h0c0-.32-.26-.57-.57-.57h0ZM16.93,12.45c-.32,0-.57.26-.57.57v3.37h-3.36c-.32,0-.57.26-.57.57s.26.57.57.57h3.94c.32,0,.57-.26.57-.57v-3.95c0-.32-.26-.57-.57-.57h0Z'
        />
    </SvgIcon>
);

export default BottomNavScanIcon;
